import React from 'react'
import classNames from 'classnames'
import { Row } from '@/components/layout/layout'

interface Props {
    type?: 'info' | 'warning'
    className?: string
    children: React.ReactNode
    action?: React.ReactNode
}

const MemberNotice: React.FC<Props> = ({ type = 'info', className, children, action }) => (
    <Row className={classNames('member-notice', `member-notice--${type}`, className)} data-align-items-center>
        <div className="member-notice__content">{children}</div>
        {action ? <div className="member-notice__action">{action}</div> : null}
    </Row>
)

export default MemberNotice
